// 商城微前端配置
import { loadMicroApp, initGlobalState, start } from 'qiankun'
import { getToken, getUserInfo } from '@/utils/auth'
import { ElMessage } from 'element-plus'

let microApp = null

// 创建全局状态管理
export const globalState = initGlobalState({
  token: getToken(),
  userInfo: getUserInfo(),
  message: '来自数字名片的消息'
})

// 监听全局状态变化
globalState.onGlobalStateChange((state, prev) => {
  console.log('全局状态变化:', state, prev)
})

// 加载商城微应用
export function loadMallMicroApp (container) {
  console.log('开始加载商城微应用')

  if (microApp) {
    console.log('微应用已存在，先卸载')
    microApp.unmount()
  }

  microApp = loadMicroApp({
    name: 'mall',
    entry: '//localhost:8011/qiankun-simple.html',
    container: container,
    props: {
      message: '来自数字名片的消息',
      token: getToken(),
      userInfo: getUserInfo(),
      globalState,
      onLoginSuccess: (token, userInfo) => {
        console.log('商城登录成功回调:', { token, userInfo })
        ElMessage.success('商城登录成功')
      },
      onLogout: () => {
        console.log('商城登出回调')
        ElMessage.success('商城登出成功')
      }
    }
  }, {
    sandbox: {
      experimentalStyleIsolation: true
    }
  })

  return microApp
}

// 卸载商城微应用
export function unloadMallMicroApp () {
  if (microApp) {
    console.log('卸载商城微应用')
    microApp.unmount()
    microApp = null
  }
}

// 更新微前端登录状态
export function updateMicroAppLoginState (token, userInfo) {
  globalState.set({
    token,
    userInfo
  })
  console.log('微前端登录状态已更新')
}

// 检查微前端状态
export function checkMicroAppState () {
  return {
    token: getToken(),
    userInfo: getUserInfo(),
    message: '来自数字名片的消息'
  }
}

// 启动微前端框架
export function startMicroApp () {
  console.log('启动微前端框架')
  start()
}
